var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`text-${_vm.type}`],style:({ fontWeight: _vm.weight }),domProps:{"textContent":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }